var render = function render(){var _vm=this,_c=_vm._self._c;return _c('group-list',{attrs:{"groups":_vm.serverGroups},on:{"add":_vm.addServerGroup,"remove":_vm.removeServerGroup,"edit":_vm.editServerGroup,"copy":_vm.copyServerGroup}})
}
var staticRenderFns = []

export { render, staticRenderFns }